<template>
  <JoszakiAutocomplete
    :value="value"
    v-bind="$attrs"
    :placeholder="placeholder ?? $t('professionTaskAutocomplete.placeholder')"
    :items="filteredProfessionTasks"
    local-filter
    @input="$emit('input', $event)"
    @search="onSearch"
    @focus="onFocus"
    v-on="$listeners"
  >
    <template #empty>
      <span>
        {{ $t("professionTaskAutocomplete.empty") }}
      </span>
    </template>
  </JoszakiAutocomplete>
</template>

<script>
import { ref, computed } from "@nuxtjs/composition-api";
import { useLazyStore } from "~/stores/lazy";

export default {
  props: {
    value: {
      type: [Object, Array],
      default: () => null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    professionId: {
      type: String,
      default: null,
    },
  },
  setup(props, { emit }) {
    const lazyStore = useLazyStore();

    const searchValue = ref("");

    const onSearch = (search) => {
      searchValue.value = search;
      emit("search", search);
    };

    const onFocus = () => {
      lazyStore.loadProfessionTasks();
      emit("focus");
    };

    const filteredProfessionTasks = computed(() => {
      if (!props.professionId) {
        return lazyStore.professionTasks;
      }
      const professionTasks = lazyStore.professionTasks.map(
        (professionTask) => ({
          ...professionTask,
          professionIds: professionTask.professions.map((profession) =>
            Number(profession.id)
          ),
        })
      );

      return professionTasks.filter((professionTask) =>
        professionTask.professionIds.includes(Number(props.professionId))
      );
    });

    return {
      filteredProfessionTasks,
      onFocus,
      onSearch,
    };
  },
};
</script>
